import React from "react";
import moment from "moment";
import { ReactComponent as Remove } from "../../../assets/icons/remove.svg";

/**
 * @param {Object} options
 * @param {(e: React.MouseEvent, id: string) => void} options.onRemove
 */
export function getNursesListColumns({ onRemove }) {
  return [
    {
      id: "name",
      accessorKey: "name",
      header: "Name",
      cell: ({ row }) => <span>{row.original?.name ?? "—"}</span>,
    },
    {
      id: "job_title",
      accessorKey: "job_title",
      header: "Position",
      cell: ({ row }) => <span className="block">{row.original?.job_title ?? "—"}</span>,
    },
    {
      id: "registered",
      accessorKey: "registered",
      header: "Registered",
      cell: ({ row }) => {
        const value = row.original?.registered;
        return <span className="block">{value ? moment(value).format("DD / MM / YYYY") : "—"}</span>;
      },
    },
    {
      id: "remove",
      header: "Remove",
      enableSorting: false,
      cell: ({ row }) => (
        <div
          className="flex justify-end"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          role="presentation"
        >
          <Remove
            className="cursor-pointer"
            onClick={(e) => onRemove(e, row.original.id)}
            data-testid={`nurses-remove-${row.original.id}`}
          />
        </div>
      ),
      meta: { disableFilterMenu: true, align: "right" },
    },
  ];
}
